export const ERROR_SUCCESS_MESSAGES = {
  errorMsg: 'Failed to save.',
  successMsg: 'Saved! Your changes may take a minute to reflect on the platform.',
};
